export default "__VITE_ASSET__a7af0dfa__"